<template>
  <div>
    <section :id="'cat-' + key" v-for="(category, key) in categories" :key="category.id">
      <h2 class="text-center category--name" style="">{{ category.name }}</h2>
      <div class="row justify-content-start">
        <div class="col-md-4 equal" v-for="product in category.products" :key="product.id">
          <div class="product-block">
            <img style="width:100%;" v-lazy="config.url + config.img_url + config.id + '/' + product.image">
            <div class="productss">
              <h3 class="name">{{ product.name }}</h3>
            <p class="text-left prodDescr" style="margin-bottom: 5px;">{{ product.description }}</p>
            <p class="text-left" v-if="product.gramm" style="margin-bottom:75px;">Вес: {{ product.gramm}} гр.</p>
            <section class="buy-block text-center">
              <div class="col-md-12">
                <span class="price" style="font-size:20px; text-decoration: line-through;" v-if="product.old_price"><span>{{ product.old_price}}</span> руб</span>
                </br>
                <span class="price" style="font-size:14px;" v-if="product.old_price"><span>Скидка {{ Math.round(100 - (product.price / (product.old_price / 100))) }}</span> %</span>
                </br>
                <span class="price"><span style="font-size:32px;">{{ product.price}}</span> руб</span>
                <div class="row" v-if="!qtyInCart(product.id)">
                  <div class="col-md-10 offset-md-1" >
                  <button  class="btn-buy btn btn-lg btn-block" @click="addToCart(product)">в
                  корзину</button>
                </div>
                </div>
                <section v-else>
                  <i class="fa cursor fa-minus-circle" @click="dec(product.id)"></i>
                  <span>{{ qtyInCart(product.id) }} шт.</span>
                  <i class="fa fa-plus-circle cursor" @click="inc(product.id)"></i>
                </section>
              </div>

            </section>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<style>
.productss {
  padding: 0px 10px 90px 10px;
}
</style>


<script>
  export default {
    computed: {
      config() {
        return this.$store.state.config;
      },
      categories() {
        return this.$store.state.categories;
      },
    },
    mounted() {
      var prodDescrWidth = $('.prodDescr').width();
      $('.buy-block').css({
        width: prodDescrWidth + 'px',
      });
    },
    methods: {
      qtyInCart(id) {
        var found = _.find(this.$store.state.cart, ["id", id]);
        if (typeof found == "object") {
          return found.qty;
        } else {
          return 0;
        }
      },
      addToCart(product) {
        this.$store.commit({
          type: "addtocart",
          product
        });
      },
      inc(id) {
        this.$store.commit({
          type: "inc",
          id
        });
      },
      dec(id) {
        this.$store.commit({
          type: "dec",
          id
        });
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Home/products.vue